import { render, staticRenderFns } from "./PreProjectsDataTable.vue?vue&type=template&id=3d66ee67"
import script from "./PreProjectsDataTable.vue?vue&type=script&lang=js"
export * from "./PreProjectsDataTable.vue?vue&type=script&lang=js"
import style0 from "./PreProjectsDataTable.vue?vue&type=style&index=0&id=3d66ee67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports